import {
  ChevronUpIcon,
  EditIcon,
  IconButtonColorEnum,
  IconButtonSection,
  IconButtonSectionInternalProps,
  IconButtonSectionSizeEnum,
  ImageThumbnail,
  ImageThumbnailSizesEnum,
  TextOrientationEnum,
  Typography,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ItemList } from '@/components/ItemList';
import { StateActiveInTable } from '@/components/StateActiveInTable/StateActiveInTable';
import { UserAction } from '@/components/UserAction';
import { TFeaturedPeopleType } from '@/features/featured-people/types';

const internalPropsIconButtonEditUser: IconButtonSectionInternalProps = {
  icon: {
    type: EditIcon,
  },
  iconButton: {
    color: IconButtonColorEnum.NONE_DEFAULT,
  },
  text: {
    value: 'Editar',
    orientation: TextOrientationEnum.LEFT,
    className: 'text-text-dark-10 text-body-3 font-regular',
  },
};

type FeaturedPeopleDetailsProps = {
  featuredPeople: TFeaturedPeopleType;
  onUpdate: (featuredPeople: TFeaturedPeopleType) => void;
};

export function FeaturedPeopleDetail({ featuredPeople, onUpdate }: FeaturedPeopleDetailsProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-1 flex-col items-start self-stretch">
      <div className="flex items-start justify-end self-stretch">
        <IconButtonSection
          onClick={() => onUpdate(featuredPeople)}
          internalProps={internalPropsIconButtonEditUser}
          size={IconButtonSectionSizeEnum.LG}
        />
      </div>
      <div className="flex w-full flex-col divide-y divide-stroke-20">
        <ItemList title={t('Imagen')}>
          <div className="flex items-center gap-2">
            <ImageThumbnail
              src={featuredPeople.parameters?.main_logo_presigned_url}
              size={ImageThumbnailSizesEnum.Xxl}
            />
            <Typography content={featuredPeople.name} />
            <Typography content={featuredPeople.surname} />
          </div>
        </ItemList>
        <ItemList title={t('Alias')}>{featuredPeople.alias}</ItemList>
        <ItemList title={t('Descripción')}>{featuredPeople.description}</ItemList>
        <ItemList title={t('Estado')}>
          <StateActiveInTable status={featuredPeople.state} />
        </ItemList>
        <ItemList title={t('Detección de imágenes')}>
          {featuredPeople.active_detection ? t('SI') : t('NO')}
        </ItemList>
        <ItemList title={t('Referencias IA')}>
          <button
            className="flex w-full items-center justify-between outline-none"
            type="button"
            onClick={() => {
              setOpen(!open);
            }}
          >
            <ChevronUpIcon
              className={clsx(
                'mr-size-8 transition-transform duration-500',
                !open ? '-rotate-180' : 'rotate-0'
              )}
            />
          </button>
        </ItemList>
        {open && (
          <div className="flex border-separate items-center gap-2 p-2">
            {featuredPeople.parameters?.logos_presigned_urls?.map(logo => (
              <ImageThumbnail src={logo} size={ImageThumbnailSizesEnum.Xxl} />
            ))}
          </div>
        )}
        <ItemList title={t('Creado por')}>
          <UserAction
            id={featuredPeople?.created_by || new Date().toISOString()}
            timestamp={featuredPeople?.created_at || new Date().toISOString()}
          />
        </ItemList>
        <ItemList title={t('Actualizado por')}>
          <UserAction
            id={featuredPeople?.created_by || new Date().toISOString()}
            timestamp={featuredPeople?.created_at || new Date().toISOString()}
          />
        </ItemList>
      </div>
    </div>
  );
}
